import React from 'react';
import { connect } from 'react-redux';

import { updateDropZone } from 'store/common/commonActions';

import { fetchAdministrationClientsPrioritaires, importClientsPrioritaires, clearClientsPrioritaires, exportClientsPrioritaires } from 'store/administration/administrationActions';
import AdministrationClients from './AdministrationClients';
import withLoader from 'components/Shared/withLoader';

import { ImportClientsPrioritairesSteps } from './ImportClientsPrioritairesSteps.js';


const AdministrationClientsWithLoader = withLoader(AdministrationClients);

class AdministrationClientsContainer extends React.Component {

    constructor(props) {
        super(props);

        // Initialisation du state
        this.state = this.getInitialState();
    }

    getInitialState = () => {
        const initialState = {
            fichiersIds: [],
            step: ImportClientsPrioritairesSteps.WaitFile,
            clientsPrioritaires: []
        };
        return initialState;
    }

    async componentDidMount() {
        var dropZone = {
            fichiers: []
        };
        await this.props.updateDropZone(dropZone);
    }


    async UNSAFE_componentWillUpdate(nextProps, nextState) {

        const { isLoadingFile, isPatching } = this.props;
        

        if (isLoadingFile === true && nextProps.isLoadingFile === false) {

            this.setState(
                {
                    ...this.state,
                    step: ImportClientsPrioritairesSteps.SetClientsPrioritaires,
                    clientsPrioritaires: { ...nextProps.clientsPrioritaires }
                });
        }

        if (isPatching === false && nextProps.isPatching === true) {
            this.setState(
                {
                    ...this.state,
                    step: ImportClientsPrioritairesSteps.WaitImport
                });
        }

        if (isPatching === true && nextProps.isPatching === false) {
            this.setState(
                {
                    ...this.state,
                    step: ImportClientsPrioritairesSteps.ImportResult
                });
        }
    }


     
    async componentDidUnmout() {
        await this.props.clearClientsPrioritaires();

        // TODO clear de la suggestion client

        this.setState(this.getInitialState());
    }

    handleChange = (event) => {
        
        const newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };

        if (event.target.name === 'fichiersIds') {
            if (newState.fichiersIds.length) {

                newState.step = ImportClientsPrioritairesSteps.LoadFile;

                this.props.fetchAdministrationClientsPrioritaires(newState.fichiersIds[0]);
            }
        }

        this.setState(newState);
    }



    handleClickSave = () => {

        const { clientsPrioritaires } = this.props;


        const clients = clientsPrioritaires.filter(client => !client.erreur && !(client.changement === 0) && !(client.changement === 3))
            .map(client => {
                var c = {
                    clientId: client.clientId,
                    prioritaire: client.changement === 1
                };
                return c;
            });
        
        this.props.importClientsPrioritaires(clients);
    }



    handleClickCancel = () => {
        var dropZone = {
            fichiers: []
        };
        this.props.updateDropZone(dropZone);

        this.setState(this.getInitialState());
    }


    handleClickExport = () => {
        this.props.exportClientsPrioritaires();
    }

    

    render() {
        const { step, clientId } = this.state;
        const { isLoading, isPatching, clientsPrioritaires, error, importResult } = this.props;


        clientsPrioritaires.sort((a, b) =>
            a.erreur !== b.erreur ? (a.erreur ? -1 : 1) :
                a.changement !== b.changement ? ((a.changement < b.changement) ? 1 : 0) :
                    ((a.codeClient <= b.codeClient) ? -1 : 1));
        
        let sauvegardable = clientsPrioritaires.filter(client => !client.erreur && client.changement !== 0 && client.changement !== 3).length > 0;

        return (
            <AdministrationClientsWithLoader
                isLoading={isLoading}
                isPatching={isPatching}
                onChange={this.handleChange}
                step={step}
                clientsPrioritaires={clientsPrioritaires}

                onClickCancel={this.handleClickCancel}
                onClickSave={this.handleClickSave}
                onClickExport={this.handleClickExport}

                importResult={importResult}
                error={error}
                sauvegardable={sauvegardable}

                clientId={clientId}
            />
        );
    }
}

const mapStateToProps = state => ({
    isPatching: state.administration.clients.prioritaires.isPatching,
    isLoadingFile: state.administration.clients.prioritaires.isLoading,
    clientsPrioritaires: state.administration.clients.prioritaires.items,
    error: state.administration.clients.prioritaires.error,
    importResult: state.administration.clients.prioritaires.importResult
});

const mapDispatchToProps = dispatch => ({
    fetchAdministrationClientsPrioritaires: (fichierId) => dispatch(fetchAdministrationClientsPrioritaires(fichierId)),
    updateDropZone: (dropZone) => dispatch(updateDropZone(dropZone)),
    importClientsPrioritaires: (clientsPrioritaires) => dispatch(importClientsPrioritaires(clientsPrioritaires)),
    clearClientsPrioritaires: () => dispatch(clearClientsPrioritaires()),    
    exportClientsPrioritaires: () => dispatch(exportClientsPrioritaires())    
});

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationClientsContainer);